import { REGEXP_ONLY_DIGITS } from 'input-otp'
import { cn } from 'lib/utils'
import * as React from 'react'
import { InputOTP, InputOTPGroup, InputOTPSlot } from '../primitives/input-otp'

interface OTPInputProps {
  value: string
  onChange: (value: string) => void
  maxLength?: number
  disabled?: boolean
  className?: string
  'data-testid'?: string
  onComplete?: (value: string) => void
  pattern?: string
  autoFocus?: boolean
}

export const OTPInput = React.forwardRef<React.ElementRef<typeof InputOTP>, OTPInputProps>(
  (
    {
      value,
      onChange,
      maxLength = 6,
      disabled = false,
      className,
      'data-testid': testId,
      onComplete,
      pattern,
      autoFocus = true,
      ...props
    },
    ref,
  ) => {
    const handleChange = (newValue: string) => {
      onChange(newValue)

      // Call onComplete when the OTP is fully filled
      if (onComplete && newValue.length === maxLength) {
        onComplete(newValue)
      }
    }

    return (
      <div className={cn('flex', className)}>
        <InputOTP
          ref={ref}
          maxLength={maxLength}
          value={value}
          onChange={handleChange}
          disabled={disabled}
          data-testid={testId}
          pattern={REGEXP_ONLY_DIGITS}
          autoFocus={autoFocus}
          {...props}
        >
          <InputOTPGroup>
            {Array.from({ length: maxLength }, (_, index) => (
              <InputOTPSlot
                key={index}
                className={cn('mr-3 rounded-md border border-solid border-border')}
                index={index}
                data-disabled={disabled}
              />
            ))}
          </InputOTPGroup>
        </InputOTP>
      </div>
    )
  },
)

OTPInput.displayName = 'OTPInput'
